import Reports from "../../../views/practice/reports/Reports";

const reportsRoutes = [
  {
    path: '/practice/reports',
    element: <Reports/>
  }
];

export default reportsRoutes;
